import GoHome from './GoHome'

export default GoHome
